"use strict";

exports.__esModule = true;
exports.CalendarEventClassificationStateField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _PlantStateActivities = require("../../PlantStateActivities");
var _ClassificationSelector = require("../../Operator/ClassificationSelector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var validate = function validate(input) {
  if (!input) {
    return "Classification State is required.";
  }
};
var CalendarEventClassificationStateField = exports.CalendarEventClassificationStateField = function CalendarEventClassificationStateField(_ref) {
  var prefix = _ref.prefix;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivities.PlantStateActivitiesContext));
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    key: prefix,
    name: prefix,
    validate: validate
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("CalendarEventClassificationStateField.helperText", "The state / activity to classify as."),
      label: translate("CalendarEventClassificationStateField.label", "State / Activity"),
      labelFor: "type",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_ClassificationSelector.ClassificationSelector, {
      "data-testid": "CalendarEventClassificationSelector",
      plantStateActivities: plantStateActivities,
      activityPredicate: function activityPredicate(state) {
        if (state.id === "data-unavailable") {
          return false;
        }
        if (state.id === "producing") {
          return false;
        }
        return true;
      },
      selected: input.value,
      onChange: function onChange(_ref3) {
        var state = _ref3.state,
          activity = _ref3.activity;
        return input.onChange({
          state: state ? state.id : null,
          activity: activity ? activity.id : null
        });
      }
    }, translate("CalendarEventClassificationStateField.placeholder", "Select State / Activity")));
  });
};